// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__izZxT","title":"AfterFrontImage_title__3e46c"};